import { ContextualConsent } from "@brynlabs/consent-next"
import PropTypes from "prop-types"
import React from "react"

import "./inline-youtube-video.sass"

const InlineYoutubeVideo = ({ youtubeId }) => {
  return (
    <div className={"_fp-inline-youtube-video"}>
      <ContextualConsent contextualConsent={"youtube"}>
        <iframe
          title={`YouTube Video ${youtubeId}`}
          src={"https://www.youtube-nocookie.com/embed/" + youtubeId}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </ContextualConsent>
    </div>
  )
}

InlineYoutubeVideo.propTypes = {
  youtubeId: PropTypes.string.isRequired,
}

export default InlineYoutubeVideo
